export default function HeroSection() {
  const stats = [
    { value: '3,200+', label: '韩漫作品' },
    { value: '每日更新', label: '同步韩网' },
    { value: '全免费', label: '零门槛阅读' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/80 via-background-50 to-accent-50/60"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-16">
        <div className="w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              韩漫追更首选平台
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              香香漫画
              <span className="block text-foreground-600 font-normal text-xl md:text-2xl lg:text-3xl mt-1">
                韩漫免费阅读平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-medium mb-6">
              海量韩漫全集 · 下拉式畅读 · 每日同步更新
            </p>

            <div className="max-w-xl mx-auto lg:mx-0">
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
                香香漫画是专注韩漫免费阅读的综合平台，收录超过三千部韩漫全集，涵盖恋爱、奇幻、动作、悬疑、穿越等全部热门类型。采用下拉式阅读模式，手机端体验丝滑流畅，无需翻页即可沉浸追漫。每日同步韩国官方最新话更新，让你永远走在剧情最前线。无论是最新韩漫追更，还是经典完结韩漫回顾，好看的韩漫在这里一网打尽。
              </p>
              <p className="text-foreground-500 text-sm leading-relaxed mb-6">
                当前热门：<strong className="text-foreground-700">《我独自升级》</strong>暗影君主篇、<strong className="text-foreground-700">《全知读者视角》</strong>星流篇、<strong className="text-foreground-700">《再婚皇后》</strong>宫廷逆袭篇 持续高能连载中。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-book-open-line"></i>
                开始阅读
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-200 text-primary-600 font-medium text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-timer-line"></i>
                查看最新更新
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/40 via-accent-200/30 to-secondary-200/40 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden bg-background-100/50 backdrop-blur-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20art%20collage%20with%20various%20characters%20in%20dynamic%20poses%2C%20fantasy%20romance%20action%20mix%2C%20vibrant%20warm%20colors%2C%20modern%20illustration%20style%2C%20cinematic%20composition%20with%20soft%20gradient%20background%2C%20professional%20manga%20art%20quality&width=600&height=750&seq=hero-main-visual&orientation=portrait"
                  alt="香香漫画 - 韩漫免费阅读平台主视觉"
                  className="w-full h-auto object-cover"
                  width="600"
                  height="750"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}